import { InputLabelProps } from "@mui/material/InputLabel";
import {
  DateOrTimeView,
  DateTimePicker,
  LocalizationProvider,
  TimePicker,
  TimeView,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { Moment } from "moment";
import { DateTimeFormats } from "../utils/DateFormatter";

export interface IDateTimeInputProps {
  type: "date" | "time" | "datetime";
  label: string;
  name: string;
  value: string | any;
  format: DateTimeFormats;
  classes?: any;
  hasError?: string | boolean;
  isDisabled?: boolean;
  minDate?: Moment;
  maxDate?: Moment;
  size?: "small" | "medium";
  onChange?: (e: any) => void;
  InputLabelProps?: InputLabelProps;
  [key: string]: any;
  timeSteps?: { minutes: number };
}
export const DateTimeInput = ({
  label,
  value,
  type = "datetime",
  format,
  name,
  classes,
  hasError,
  onChange,
  InputLabelProps,
  MinDate,
  MaxDate,
  isDisabled = false,
  size = "medium",
  timeSteps,
  ...props
}: IDateTimeInputProps) => {
  const getDateTimeViews = (format: DateTimeFormats): DateOrTimeView[] => {
    switch (format) {
      case DateTimeFormats.DateFormat:
        return ["year", "month", "day"];
      case DateTimeFormats.DateTimeFormatWithoutSeconds:
        return ["year", "month", "day", "hours", "minutes"];
      case DateTimeFormats.TimeFormat:
        return ["hours", "minutes"];
      default: //full date time
        return ["year", "month", "day", "hours", "minutes", "seconds"];
    }
  };

  const getTimeViews = (format: DateTimeFormats): TimeView[] => {
    switch (format) {
      case DateTimeFormats.TimeFormat:
        return ["hours", "minutes"];
      default: //full date time
        return ["hours", "minutes", "seconds"];
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {type === "time" ? (
        <TimePicker
          label={label}
          name={name}
          ampm={false}
          views={getTimeViews(format)}
          className={`${classes} ${hasError && "warningStyles"}`}
          value={moment(value, format) || ""}
          format={format}
          onChange={onChange}
          {...props}
          timeSteps={timeSteps}
          slotProps={{
            textField: {
              variant: "outlined",
              required: true,
              error: !!hasError,
              fullWidth: true,
              helperText: hasError,
              size: size,
              disabled: isDisabled,
              inputProps: {
                type: "text",
                InputLabelProps: { InputLabelProps },
                // style: { color: !value ? "var(--color-error-main)" : "" },
              },
            },
          }}
        />
      ) : (
        <DateTimePicker
          label={label}
          name={name}
          ampm={false}
          minDateTime={MinDate}
          maxDateTime={MaxDate}
          views={getDateTimeViews(format)}
          className={`${classes}`}
          value={moment(value, format) || ""}
          format={format}
          onChange={onChange}
          {...props}
          slotProps={{
            textField: {
              variant: "outlined",
              required: true,
              error: !!hasError,
              fullWidth: true,
              helperText: hasError,
              size: size,
              disabled: isDisabled,
              inputProps: {
                type: "text",
                inputlabelprops: { InputLabelProps },
                style: {
                  color: hasError ? "var(--color-error-main)" : "",
                },
              },
            },
          }}
        />
      )}
    </LocalizationProvider>
  );
};
